import React, {Component} from 'react';
import './RmButton.css';
import PropTypes from 'prop-types';
import LoadingSpinner from "./LoadingSpinner";
import Cappy from "../Etc/Cappy";

export default class RmButton extends Component {
    render() {
        let classNames = ["RmButton"];

        if (this.props.busy) {
            classNames.push("RmButton__busy");
        }

        if (this.props.className) {
            classNames.push(this.props.className);
        }

        let inner = (
            <div>
                <span>{Cappy.onlyFirst(this.props.label)}</span>
                {this.props.busy && <div className={"RmButton__spinner"}>
                    <LoadingSpinner/>
                </div>}
            </div>
        );

        if (this.props.href) {
            return (
                <a className={classNames.join(' ')} title={this.props.label} href={this.props.href}
                   onClick={this.props.onClick}>
                    {inner}
                </a>
            );
        } else {
            return (
                <button type={"button"} className={classNames.join(' ')} title={this.props.label}
                   onClick={this.props.onClick}>
                    {inner}
                </button>
            )
        }
    }
}

RmButton.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    busy: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Common/RmButton.js